const routes = {
	'/financial-details': '账务明细',
};

export {
	routes,
};
